import { useState, useEffect } from 'react'
import { Icon } from '@iconify/react'
import { useGlobalContext } from '../../../../utils/Context'
import { SpecifyItem } from './components/SpecifyItem'
import { Newcountries } from '../../../../utils/Locals'
import StateData from '../../../../assets/data/StateData'
import moment from 'moment'
import { post, get, upload } from '../../../../utils/Api'
import FormLoader from '../../../../components/loader/FormLoader'
// import Paystack from '@paystack/inline-js'
import Modal from '../../../../components/modal/Modal'
import { useNavigate, useLocation } from 'react-router-dom'
import CountryPhone from '../../../../assets/data/CountryPhone'
import PageLoader from '../../../../components/loader/PageLoader'
import { trackFunnelStep } from '../../../../utils/googleAnalytics'
import DeliveryBanner from '../../../../components/deliveryBanner/deliveryBanner'
import SummaryBanner from '../../../../components/deliveryBanner/SummaryBanner'

function Domestic() {
  const navigate = useNavigate()
  const { notify, profile, fetchUserProfile } = useGlobalContext()
  const [tab, setTab] = useState(1)
  const [delivery, setDelivery] = useState<any>({
    shipment_type: 'Package',
    packages: [
      {
        weight: 0,
        dimensions: { length: 0, width: 0, height: 0 },
      },
    ],
    weight: '',
    length: '',
    width: '',
    pickup_date: '',
    height: '',
    description: '',
    city: '',
    email: '',
    state: '',
    value: '',
    // pickup_address: addval ? data[addval] : '',
    // pickup_hub: addval,
    pickup_number: '',
    // useDefaultAddress: auth?.address,
    country: 'NG',
    delivery_address: '',
    delivery_state: '',
    receiver_first_name: '',
    receiver_last_name: '',
    sender_first_name: '',
    sender_last_name: '',
    sender_company: '',
    postcode: '',
    delivery_email: '',
    delivery_number: '',
    receiverCountry: 'NG',
    receiver_company: '',
    Deliverypostcode: '',
    delivery_city: '',
    packageImage: '',
  })
  const [continues, setContinues] = useState(false)
  const [insurance, setInsurance] = useState(false)
  const handleChange = ({ target }: any) => {
    setDelivery({ ...delivery, [target.name]: target.value })
  }
  const handleTab = (e: any) => {
    if (tab != 2) {
      e.preventDefault()
    }

    if (tab === 1) {
      const errors = []

      if (delivery.shipment_type === '') {
        errors.push('Shipment type')
      }
      if (delivery.purpose === '') {
        errors.push('purpose')
      }
      delivery.packages.forEach((pkg: any, index: number) => {
        if (pkg.weight === 0) {
          errors.push(`Weight for package ${index + 1}`)
        }
        if (pkg.dimensions.length === 0) {
          errors.push(`Length for package ${index + 1}`)
        }
        if (pkg.dimensions.width === 0) {
          errors.push(`Width for package ${index + 1}`)
        }
        if (pkg.dimensions.height === 0) {
          errors.push(`Height for package ${index + 1}`)
        }
      })

      const totalWeight = delivery.packages.reduce(
        (acc: number, pkg: any) => acc + pkg.weight,
        0
      )
      if (delivery.shipment_type === 'Document' && totalWeight > 2) {
        errors.push(
          'You selected Document as a shipment type, total weight must not be greater than 2'
        )
      }
      if (delivery.description.length > 70) {
        errors.push('Description is too long')
      }
      if (delivery.description === '') {
        errors.push('Description')
      }

      if (delivery.value === '') {
        errors.push('Value')
      }

      if (errors.length > 0) {
        return notify('error', `${errors.join(', ')} is required`)
      }
      trackFunnelStep('Domestic Step 2')
      if (image) {
        handleImageUpload()
      }
      setTab(2)
    }

    if (tab === 2) {
      trackFunnelStep('Domestic Step 3')
      setTab(3)
    }

    if (tab === 3) {
      const errors = []
      if (delivery.sender_first_name === '') {
        errors.push('Sender First name')
      }
      if (delivery.sender_last_name === '') {
        errors.push('Sender Last name')
      }
      if (delivery.pickup_address === '') {
        errors.push('Pick up address')
      }
      if (delivery.pickup_address.length > 45) {
        errors.push('Pick up address is too long manually reduce it.')
      }
      if (delivery.country === '') {
        errors.push('Country')
      }

      if (delivery.state === '') {
        errors.push('State')
      }

      if (delivery.city === '') {
        errors.push('City')
      }

      if (delivery.postcode === '') {
        errors.push('Post code')
      }

      if (delivery.pickup_number === '') {
        errors.push('Phone number')
      }

      const phoneData: any = CountryPhone.find(
        (data: any) => data.isoCode === delivery.country
      )
      if (
        delivery.pickup_number.length < phoneData.phoneLength.min ||
        delivery.pickup_number.length > phoneData.phoneLength.max
      ) {
        errors.push('Phone number length needs to be valid')
      }
      if (errors.length > 0) {
        return notify('error', `${errors.join(', ')} is required to continue`)
      }
      trackFunnelStep('Domestic Step 4')
      setTab(4)
    }

    if (tab === 4) {
      // handleBooking();
      const errors = []

      if (delivery.receiver_first_name === '') {
        errors.push('Receiver name')
      }
      if (delivery.receiver_last_name === '') {
        errors.push('Receiver name')
      }

      if (delivery.delivery_address === '') {
        errors.push('Address')
      }
      if (delivery.delivery_address.length > 45) {
        errors.push('Pick up address is too long manually reduce it.')
      }

      if (delivery.receiverCountry === '') {
        errors.push('Country')
      }

      if (delivery.delivery_state === '') {
        errors.push('Receiver state')
      }

      if (delivery.delivery_city === '') {
        errors.push('Receiver City')
      }

      if (delivery.Deliverypostcode === '') {
        errors.push('Receiver Postcode')
      }

      if (delivery.pickup_date === '') {
        errors.push('Date')
      }

      if (delivery.delivery_email === '') {
        errors.push('Receiver email')
      }

      if (delivery.delivery_number === '') {
        errors.push('Receiver mobile number')
      }
      const phoneData: any = CountryPhone.find(
        (data: any) => data.isoCode === delivery.receiverCountry
      )
      if (
        delivery.delivery_number.length < phoneData.phoneLength.min ||
        delivery.delivery_number.length > phoneData.phoneLength.max
      ) {
        errors.push('Phone number length needs to be valid')
      }

      if (errors.length > 0) {
        return notify('error', `${errors.join(', ')} is required to continue`)
      }
      getPrice()
    }

    if (tab === 5) {
      // BookDel()
    }
  }
  function showHeader() {
    switch (tab) {
      case 1:
        return 'Shipment Details'
      case 2:
        return 'Specify items in package'
      case 3:
        return 'PickUp Information'
      case 4:
        return 'Delivery Information'
      case 5:
        return 'Shipment Summary'
      default:
        return ''
    }
  }
  const [prohibitedItem, setProhibitedItem] = useState(false)

  //<----------------------Fetch------>
  useEffect(() => {
    fetchUserProfile()
    trackFunnelStep('Domestic Step 1')
  }, [])

  //<-------------- Specific Items ----------->
  const [specifiedItems, setSpecifiedItems] = useState<any>([
    {
      itemName: '',
      description: '',
      itemQuantity: '',
      netValue: '',
      grossValue: '',
      itemValue: '',
      commodityCodes: { value: '', label: '' },
    },
  ])
  const handleSpecifiedItemSubmit = (data: any) => {
    // setTab()
    setSpecifiedItems(data)
    handleTab({})
  }

  //<--------------- Locations ----------->
  const [pickUpCities, setPickupCities] = useState<any>([])
  const handleCities = (state: string) => {
    const PickedState: any = StateData.find((item) => item.state.name === state)
    setPickupCities(PickedState.state.locals)
  }
  const [deliveryCities, setDeliveryCities] = useState([])
  const handleDeliveryCities = (state: string) => {
    const PickedState: any = StateData.find((item) => item.state.name === state)
    setDeliveryCities(PickedState.state.locals)
  }

  const capitalizeFirstLetter = (string: string) => {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }

  const fixAllCap = (string: string) => {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
  }
  //<----------------- Get Cost --------------- >
  const [loading, setLoading] = useState(false)
  const [total, setTotal] = useState<any>({
    shippingCost: 0,
    insurance: 0,
    totalPrice: 0,
  })
  const getPrice = async () => {
    let Newdata = {
      plannedShippingDateAndTime: `${moment(delivery.pickup_date).format(
        'YYYY-MM-DD'
      )}T${moment(delivery.pickup_date).format('hh:mm:ss')} GMT+01:00`,
      isCustomsDeclarable: false,
      document:
        delivery.shipment_type.toLocaleLowerCase() === 'document'
          ? 'document'
          : 'non_document',
      nextBusinessDay: true,
      // insurance: insurance,
      deliveryType: 'domestic',
      customerDetails: {
        shipperDetails: {
          postalCode: delivery.postcode,
          cityName: capitalizeFirstLetter(delivery.city),
          countryCode: 'NG',
          addressLine1: delivery.pickup_address,
          // countyName: filterPickupCountry[0].name,
          countyName: delivery.state,
        },
        receiverDetails: {
          postalCode: delivery.Deliverypostcode,
          cityName: capitalizeFirstLetter(delivery.delivery_city),
          countryCode: 'NG',
          addressLine1: delivery.delivery_address,
          // countyName: filterreceiverCountry[0].name,
          countyName: delivery.delivery_state,
        },
      },
      monetaryAmount: [
        {
          typeCode: 'declaredValue',
          value: Number(delivery.value),
          currency: 'NGN',
        },
      ],
      packages: delivery.packages,
    }
    setLoading(true)
    post('price/admin-single', Newdata, null)
      .then((result: any) => {
        if (result.status === 200) {
          setTotal(result?.data)
          trackFunnelStep('Domestic Step 5')
          setTab(5)
        } else {
          notify('error', result.message)
        }
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  //<------------------------- Payment ------------------->
  /// payment
  // const popup = new Paystack()
  // const initiatePayment = async () => {
  //   const data = {
  //     amount: parseFloat(total).toFixed(2),
  //     usage: 'booking',
  //   }

  //   setLoading(true)
  //   post('payment/initialize', data, null)
  //     .then((result: any) => {
  //       if (result.status === 200) {
  //         notify('success', result.message)
  //         popup.newTransaction({
  //           key: 'pk_test_3de3e1d2ebe11f74d69ea6ff22341d681a7dc5d5', // Replace with your public Paystack key
  //           reference: result.data.reference,
  //           amount: parseFloat((parseFloat(total) * 100).toFixed(2)),
  //           email: profile.email,
  //           onSuccess: () => {
  //             // Redirect to the backend to verify payment
  //             verifyPayment(result.data.reference)
  //           },
  //           onCancel: () => {
  //             verifyPayment(result.data.reference)
  //           },
  //         })
  //       } else {
  //         notify('error', result.er.message)
  //       }
  //       setLoading(false)
  //     })
  //     .catch(() => {
  //       setLoading(false)
  //     })
  // }
  // hideLoader()
  // const verifyPayment = async (id: string) => {
  //   setLoading(true)
  //   get(`payment/verify/${id}`)
  //     .then((result: any) => {
  //       if (result.status === 200) {
  //         setLoading(false)
  //         handleBooking()
  //       } else {
  //         notify('error', result.message)
  //       }
  //     })
  //     .catch(() => {
  //       setLoading(false)
  //     })
  // }

  //<------------- Handle Booking ---------->
  const [modalConfirm, setModalConfirm] = useState(false)
  const [trackingId, setTrackingId] = useState<any>({})

  // const handleBooking = async (paymentMethod: string) => {
  //   const filterPickupCountry = Newcountries.filter((c) => {
  //     return c.isoCode == delivery.country
  //   })

  //   const filterreceiverCountry = Newcountries.filter((c) => {
  //     return c.isoCode == delivery.receiverCountry
  //   })
  //   const senderPhoneData: any = CountryPhone.find(
  //     (data: any) => data.isoCode === delivery.country
  //   )
  //   const recieverPhoneData: any = CountryPhone.find(
  //     (data: any) => data.isoCode === delivery.receiverCountry
  //   )

  //   const Newdata = {
  //     type: 'DOMESTIC',
  //     paymentMethod: paymentMethod,
  //     charge: parseFloat(total.totalPrice).toFixed(2),
  //     insurance: insurance,
  //     shipmentData: {
  //       plannedShippingDateAndTime: `${moment(delivery.pickup_date).format(
  //         'YYYY-MM-DD'
  //       )}T${moment(delivery.pickup_date).format('hh:mm:ss')} ${new Date()
  //         .toLocaleDateString('en-US', {
  //           day: '2-digit',
  //           timeZoneName: 'short',
  //         })
  //         .slice(4)
  //         .slice(0, -2)}+01:00`,
  //       pickup: false,
  //       // plannedShippingDateAndTime: `${moment(delivery.pickup_date)
  //       //   .utcOffset(0, false)
  //       //   .format()} `,
  //       declaredValue: delivery.value,
  //       sender: {
  //         postalAddress: {
  //           postalCode: delivery.postcode,
  //           cityName: capitalizeFirstLetter(delivery.city),
  //           countryCode: 'NG',
  //           addressLine1: delivery.pickup_address,
  //           countyName: filterPickupCountry[0].name,
  //         },
  //         contactInformation: {
  //           phone: `${senderPhoneData.phoneCode}${delivery.pickup_number}`,
  //           companyName: delivery.sender_company,
  //           fullName: `${delivery.sender_first_name} ${delivery.sender_last_name}`,
  //           email: profile.email,
  //         },
  //       },
  //       receiver: {
  //         postalAddress: {
  //           postalCode: delivery.Deliverypostcode,
  //           cityName: capitalizeFirstLetter(delivery.delivery_city),
  //           countryCode: 'NG',
  //           addressLine1: delivery.delivery_address,
  //           countyName: filterreceiverCountry[0].name,
  //         },
  //         contactInformation: {
  //           phone: `${recieverPhoneData.phoneCode}${delivery.delivery_number}`,
  //           companyName: delivery.receiver_company,
  //           fullName: `${delivery.receiver_first_name} ${delivery.receiver_last_name}`,
  //           email: delivery.delivery_email,
  //         },
  //       },
  //       packages: [
  //         {
  //           weight: Number(delivery.weight),
  //           dimensions: {
  //             length: Number(delivery.length),
  //             width: Number(delivery.width),
  //             height: Number(delivery.height),
  //           },
  //         },
  //       ],
  //       description: delivery.description.trim(),
  //     },
  //     bookingData: {
  //       category: 'Products',
  //       shipment_type: delivery.shipment_type.toUpperCase(),
  //       value: Number(delivery.value),
  //     },
  //   }

  //   setLoading(true)

  //   post('booking/create', Newdata, null)
  //     .then((result: any) => {
  //       if (result.status === 200) {
  //         notify('success', result.message)
  //         trackFunnelStep('Domestic Final Step')
  //         setTrackingId(result.data)
  //         setModalConfirm(true)
  //       } else {
  //         notify(
  //           'error',
  //           typeof result.message === 'string'
  //             ? result.message
  //             : result.message.detail
  //         )
  //       }
  //       setLoading(false)
  //     })
  //     .catch(() => {
  //       setLoading(false)
  //     })
  // }
  useEffect(() => {
    fetchUserProfile()
  }, [])
  // <--------------------- Drafts ------------------->
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const draftId = searchParams.get('draftId')
  const [bookingLoading, setBookingLoading] = useState(false)

  useEffect(() => {
    if (draftId) {
      get(`booking/fetch-draft/${draftId}`)
        .then((result: any) => {
          if (result.status === 200) {
            setDelivery({
              ...delivery,
              ...result.data,
            })
            setImagePreview(result.data.packageImage)
            setSpecifiedItems(result.data.specifiedItems)
          } else {
            notify('error', result.message)
          }
        })
        .catch(() => {
          setBookingLoading(false)
        })
    }
  }, [draftId])
  const saveToDraft = async () => {
    setLoading(true)
    const draftData = {
      ...delivery,
      userId: profile._id,
      specifiedItems,
      type: 'Domestic',
      creatorName: `${profile.firstname} ${profile.lastname}`,
    }
    post('booking/create-draft', draftData, null)
      .then((result: any) => {
        if (result.status >= 200 && result.status < 300) {
          notify('success', result.message)
          setTrackingId(result.data.drfID)
          setModalConfirm(true)
        } else {
          notify(
            'error',
            typeof result.message === 'string'
              ? result.message
              : result.message.detail
          )
        }
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }
  // async function deleteDraft() {
  //   deleteAPI(`booking/draft/${draftId}`)
  //     .then((result: any) => {
  //       if (result.status === 200) {
  //         notify('success', result.message)
  //         setTimeout(() => {
  //           navigate('/admin/bookings')
  //         }, 2000)
  //       } else {
  //         notify('error', result.message)
  //       }
  //     })
  //     .catch(() => {
  //       setBookingLoading(false)
  //     })
  // }
  const [image, setImage] = useState<any>(null)
  const [ImagePreview, setImagePreview] = useState<any>(null)

  const handleImageUpload = () => {
    const formData = new FormData()
    if (image) {
      formData.append('images', image)
    }
    upload(formData)
      .then((result: any) => {
        if (result.status === 201) {
          setImagePreview(result.image)
          setDelivery({ ...delivery, packageImage: result.image })
          setImage(null)
        } else {
          notify('error', result.message)
        }
      })
      .catch(() => {
        notify('error', 'Failed to upload image')
      })
  }
  return bookingLoading ? (
    <div className='home'>
      <PageLoader position='center' />
    </div>
  ) : (
    <div className='delivery-page flex justify-center'>
      <div className='form-wrap'>
        <div
          className='back flex items-center'
          onClick={() => {
            if (tab === 1) {
              navigate('/user/home')
            } else {
              setTab(tab - 1)
            }
          }}
        >
          <Icon icon='nrk:back' />
          <p>{tab === 1 ? 'Back' : 'Previous Tab'}</p>
        </div>
        <div className='top'>
          <h2>{showHeader()}</h2>
        </div>
        {tab === 1 && (
          <div className='form'>
            <div className='input-card'>
              <select
                className='where-address-input-option'
                name='shipment_type'
                onChange={handleChange}
                value={delivery.shipment_type}
                required
                disabled
              >
                <option value='' style={{ color: 'rgba(36, 66, 46, 0.75)' }}>
                  Select Shipment Type
                </option>
                <option value='Package'>Package</option>
              </select>
            </div>
            {delivery.packages.map((pkg: any, index: number) => (
              <div key={index} className='package-input-group'>
                <h4>Package {index + 1}</h4>
                <div className='input-card'>
                  <p>Weight (KG)</p>
                  <input
                    required
                    type='number'
                    name={`weight-${index}`}
                    min='0.5'
                    onChange={(e) => {
                      const updatedPackages = [...delivery.packages]
                      updatedPackages[index].weight = parseFloat(e.target.value)
                      setDelivery({ ...delivery, packages: updatedPackages })
                    }}
                    value={pkg.weight}
                  />
                </div>

                <div className='flex row justify-between'>
                  <div className='input-card'>
                    <p>Length (CM)</p>
                    <input
                      required
                      type='number'
                      name={`length-${index}`}
                      min='0.5'
                      onChange={(e) => {
                        const updatedPackages = [...delivery.packages]
                        updatedPackages[index].dimensions.length = parseFloat(
                          e.target.value
                        )
                        setDelivery({ ...delivery, packages: updatedPackages })
                      }}
                      value={pkg.dimensions.length}
                    />
                  </div>

                  <div className='input-card'>
                    <p>Width (CM)</p>
                    <input
                      required
                      type='number'
                      name={`width-${index}`}
                      min='0.5'
                      onChange={(e) => {
                        const updatedPackages = [...delivery.packages]
                        updatedPackages[index].dimensions.width = parseFloat(
                          e.target.value
                        )
                        setDelivery({ ...delivery, packages: updatedPackages })
                      }}
                      value={pkg.dimensions.width}
                    />
                  </div>

                  <div className='input-card'>
                    <p>Height (CM)</p>
                    <input
                      required
                      type='number'
                      name={`height-${index}`}
                      min='0.5'
                      onChange={(e) => {
                        const updatedPackages = [...delivery.packages]
                        updatedPackages[index].dimensions.height = parseFloat(
                          e.target.value
                        )
                        setDelivery({ ...delivery, packages: updatedPackages })
                      }}
                      value={pkg.dimensions.height}
                    />
                  </div>
                </div>
              </div>
            ))}

            <div className='btnsfd dif'>
              <button
                type='button'
                onClick={() => {
                  setDelivery({
                    ...delivery,
                    packages: [
                      ...delivery.packages,
                      {
                        weight: 0,
                        dimensions: { length: 0, width: 0, height: 0 },
                      },
                    ],
                  })
                }}
                className='add-package-btn'
              >
                Add Package
              </button>
              {delivery.packages.length > 1 && (
                <button
                  type='button'
                  onClick={() => {
                    const updatedPackages = [...delivery.packages]
                    updatedPackages.pop()
                    setDelivery({ ...delivery, packages: updatedPackages })
                  }}
                  className='remove-package-btn'
                >
                  Remove Last Package
                </button>
              )}
            </div>
            <div className='input-card'>
              <p>Description</p>
              <input
                required
                type='text'
                placeholder='Give a detailed description of what you are shipping'
                name='description'
                onChange={handleChange}
                value={delivery.description}
              />
            </div>

            <div className='input-card'>
              <p>Goods Value</p>
              <input
                required
                type='number'
                placeholder=''
                min='0.5'
                name='value'
                onChange={handleChange}
                value={delivery.value}
              />
            </div>
            <div className='input-card'>
              <p>Image of Package</p>
              <input
                type='file'
                accept='image/*'
                id='packageImage'
                onChange={(e) => {
                  const file = e.target.files?.[0]
                  if (file) {
                    const maxSize = 3 * 1024 * 1024 // 3MB in bytes
                    if (file.size > maxSize) {
                      notify('error', 'Image size must not exceed 3MB')
                      return
                    }
                    setImage(file)
                    setImagePreview(URL.createObjectURL(file))
                  }
                }}
                style={{ display: 'none' }}
              />
              <label
                htmlFor='packageImage'
                className='package-image-label flex items-center'
              >
                <Icon icon='mdi:image-plus' />
                {ImagePreview ? 'Image Uploaded' : 'No image selected'}
              </label>
            </div>
            <div className='input-card'>
              <button
                type='button'
                onClick={() => {
                  setProhibitedItem(true)
                }}
                className='btn-danger'
              >
                Prohibited Items
              </button>
            </div>
            <div className='btnsfd'>
              <div className='form-check'>
                <input
                  className='form-check-input'
                  type='checkbox'
                  value=''
                  id='flexCheckInsurance'
                  checked={insurance ? true : false}
                  onClick={() => {
                    setInsurance(!insurance)
                  }}
                />
                <label
                  className='form-check-label'
                  htmlFor='flexCheckInsurance'
                >
                  Shipment Protection: For just 2% of the total goods value
                  (with a minimum charge of ₦10,000), you can ensure that your
                  items are safeguarded against loss, damage, or unforeseen
                  incidents during transit.
                </label>
              </div>
            </div>
            <div className='btnsfd'>
              <div className='form-check'>
                <input
                  className='form-check-input'
                  type='checkbox'
                  value=''
                  id='flexCheckChecked'
                  checked={continues ? true : false}
                  onClick={() => {
                    setContinues(!continues)
                  }}
                />
                <label className='form-check-label' htmlFor='flexCheckChecked'>
                  By ticking the box, you agree that you have read and
                  understood the prohibited list
                </label>
              </div>
              <button
                onClick={handleTab}
                className='where-address-button'
                disabled={!continues}
              >
                Continue
              </button>
            </div>
          </div>
        )}
        {tab === 2 && (
          <SpecifyItem
            handleSpecifiedItemSubmit={handleSpecifiedItemSubmit}
            specifiedItems={specifiedItems}
            hide={true}
            delivery={delivery}
          />
        )}
        {tab === 3 && (
          <div className='form'>
            <>
              <div className='flex justify-between  row'>
                <div className='input-card'>
                  <p>Sender First Name</p>
                  <input
                    required
                    type='text'
                    placeholder='Sender Name'
                    name='sender_first_name'
                    value={delivery.sender_first_name}
                    onChange={handleChange}
                  />
                </div>
                <div className='input-card'>
                  <p>Sender Last Name</p>
                  <input
                    required
                    type='text'
                    placeholder='Sender Name'
                    name='sender_last_name'
                    value={delivery.sender_last_name}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className='input-card'>
                <p>Company</p>
                <input
                  required
                  type='text'
                  placeholder=''
                  name='sender_company'
                  value={delivery.sender_company}
                  onChange={handleChange}
                />
              </div>
              <div className='row'>
                <div className='input-card'>
                  <p>Full address including Flat/apartment Number</p>
                  <input
                    required
                    type='text'
                    placeholder=''
                    name='pickup_address'
                    value={delivery.pickup_address}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className='  row'>
                <div className='col'>
                  <div className='input-card'>
                    <p>Select Country</p>

                    <select
                      className='where-address-input-option'
                      name='country'
                      value={delivery.country}
                      disabled
                      required
                    >
                      <option value=''>Select country</option>
                      {Newcountries.map((data) => {
                        return (
                          <option value={data?.isoCode} key={data?.isoCode}>
                            {data?.name}
                          </option>
                        )
                      })}
                    </select>
                  </div>
                </div>

                <div className='  col'>
                  <div className='input-card'>
                    <p>Select state</p>

                    <select
                      className='where-address-input-option'
                      name='state'
                      onChange={async (e) => {
                        handleChange(e)
                        handleCities(e.target.value)
                      }}
                      value={delivery.state}
                      required
                    >
                      <option value=''>Select State</option>
                      {StateData.map((data) => {
                        return (
                          <option
                            value={data?.state.name}
                            key={data.state.name}
                          >
                            {data?.state.name}
                          </option>
                        )
                      })}
                    </select>
                  </div>{' '}
                </div>

                <div className='flex row'>
                  <div className='input-card'>
                    <p>City</p>
                    <select
                      className='where-address-input-option'
                      name='city'
                      onChange={(e) => {
                        handleChange(e)
                      }}
                      value={delivery.city}
                      required
                      disabled={
                        delivery.state == '' || pickUpCities.length == 0
                          ? true
                          : false
                      }
                    >
                      <option value=''>Select City</option>
                      {pickUpCities.map((data: any) => {
                        return (
                          <option value={data?.name} key={data.name}>
                            {data?.name}
                          </option>
                        )
                      })}
                    </select>
                  </div>

                  <div className='input-card'>
                    <p>Post code</p>
                    <input
                      required
                      type='text'
                      placeholder='0039282'
                      onChange={({ target }) => {
                        setDelivery({
                          ...delivery,
                          postcode: target.value,
                        })
                      }}
                      value={delivery.postcode}
                    />
                  </div>
                </div>

                {CountryPhone.filter(
                  (data: any) => data.isoCode === delivery.country
                ).map((data: any) => (
                  <div className='input-card' key={data.isoCode}>
                    <p>Phone Number</p>
                    <div className='flex items-center'>
                      <div className='flags flex items-center'>
                        <div className='flag-wrap flex items-center'>
                          <Icon
                            icon={`circle-flags:${data.isoCode.toLowerCase()}`}
                          />
                          <span>{data.phoneCode}</span>
                        </div>
                      </div>
                      <input
                        required
                        type='text'
                        placeholder='Input Phone Number'
                        name='pickup_number'
                        value={delivery.pickup_number}
                        onChange={handleChange}
                        min={data.phoneLength.min}
                        max={data.phoneLength.max}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </>

            <div className='btnsfd'>
              <button onClick={handleTab} className='where-address-button'>
                Continue
              </button>
            </div>
          </div>
        )}
        {tab === 4 && (
          <div className='form'>
            <>
              <div className='flex justify-between  row'>
                <div className='input-card'>
                  <p>Receiver First Name</p>
                  <input
                    required
                    type='text'
                    placeholder='Receiver First Name'
                    name='receiver_first_name'
                    value={delivery.receiver_first_name}
                    onChange={handleChange}
                  />
                </div>
                <div className='input-card'>
                  <p>Receiver Last Name</p>
                  <input
                    required
                    type='text'
                    placeholder='Receiver Last Name'
                    name='receiver_last_name'
                    value={delivery.receiver_last_name}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className='input-card'>
                <p>Company</p>
                <input
                  required
                  type='text'
                  placeholder=''
                  name='receiver_company'
                  value={delivery.receiver_company}
                  onChange={handleChange}
                />
              </div>
              <div className='row'>
                <div className='input-card'>
                  <p>Delivery Address</p>
                  <input
                    required
                    type='text'
                    placeholder=''
                    name='delivery_address'
                    value={delivery.delivery_address}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className=' flex justify-between  row'>
                <div className='input-card'>
                  <p>Country</p>

                  <select
                    className='where-address-input-option'
                    name='receiverCountry'
                    disabled
                    value={delivery.receiverCountry}
                    required
                  >
                    <option value=''>Select country</option>
                    {Newcountries.map((data) => {
                      return (
                        <option value={data?.isoCode} key={data?.isoCode}>
                          {data?.name}
                        </option>
                      )
                    })}
                  </select>
                </div>

                <div className='input-card'>
                  <p>Add State</p>

                  <select
                    className='where-address-input-option'
                    onChange={async (e) => {
                      handleChange(e)
                      handleDeliveryCities(e.target.value)
                    }}
                    name='delivery_state'
                    value={delivery.delivery_state}
                    required
                  >
                    <option value=''>Select State</option>
                    {StateData.map((data) => {
                      return (
                        <option value={data?.state.name} key={data.state.name}>
                          {data?.state.name}
                        </option>
                      )
                    })}
                  </select>
                </div>
              </div>
              <div className='flex justify-between row'>
                <div className='input-card'>
                  <p>City</p>
                  <select
                    className='where-address-input-option'
                    name='delivery_city'
                    onChange={(e) => {
                      handleChange(e)
                    }}
                    value={delivery.delivery_city}
                    required
                    disabled={
                      delivery.delivery_state == '' || pickUpCities.length == 0
                        ? true
                        : false
                    }
                  >
                    <option value=''>Select City</option>
                    {deliveryCities.map((data: any) => {
                      return (
                        <option value={data?.name} key={data.name}>
                          {data?.name}
                        </option>
                      )
                    })}
                  </select>
                </div>

                <div className='input-card'>
                  <p>Post code</p>
                  <input
                    required
                    type='text'
                    placeholder='0039282'
                    onChange={({ target }) => {
                      setDelivery({
                        ...delivery,
                        Deliverypostcode: target.value,
                      })
                    }}
                    value={delivery.Deliverypostcode}
                  />
                </div>
              </div>

              <div className='row'>
                {CountryPhone.filter(
                  (data: any) => data.isoCode === delivery.receiverCountry
                ).map((data: any) => (
                  <div className='input-card' key={data.isoCode}>
                    <p>Phone Number</p>
                    <div className='flex items-center'>
                      <div className='flags flex items-center'>
                        <div className='flag-wrap flex items-center'>
                          <Icon
                            icon={`circle-flags:${data.isoCode.toLowerCase()}`}
                          />
                          <span>{data.phoneCode}</span>
                        </div>
                      </div>
                      <input
                        required
                        type='text'
                        placeholder='Input Phone Number'
                        name='delivery_number'
                        value={delivery.delivery_number}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                ))}
              </div>
              <div className='row flex'>
                <div className='input-card'>
                  <p>Date</p>
                  <input
                    required
                    type='date'
                    onChange={({ target }) => {
                      setDelivery({
                        ...delivery,
                        pickup_date: target.value,
                      })
                    }}
                    min={new Date().toISOString().split('T')[0]}
                    value={delivery.pickup_date}
                  />
                </div>
                <div className='input-card'>
                  <p>Email</p>
                  <input
                    required
                    type='text'
                    placeholder='Input Email'
                    name='delivery_email'
                    value={delivery.delivery_email}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </>

            <div className='btnsfd'>
              {loading ? (
                <FormLoader position='center' />
              ) : (
                <button onClick={handleTab} className='where-address-button'>
                  Continue
                </button>
              )}
            </div>
          </div>
        )}
        {tab === 5 && (
          <div className='sumaryWrap'>
            <div className='desc'>
              <div className='flex justify-between items-center'>
                <h2>Order Description</h2>
                <p>{delivery.description}</p>
              </div>
              {delivery.packages.map((pkg: any, index: number) => (
                <div key={index}>
                  <div className='flex justify-between items-center'>
                    <h2>Package {index + 1} Weight</h2>
                    <p>{pkg.weight}KG</p>
                  </div>
                  <div className='flex justify-between items-center'>
                    <h2>Package {index + 1} Length</h2>
                    <p>{pkg.dimensions.length}CM</p>
                  </div>
                  <div className='flex justify-between items-center'>
                    <h2>Package {index + 1} Width</h2>
                    <p>{pkg.dimensions.width}CM</p>
                  </div>
                  <div className='flex justify-between items-center'>
                    <h2>Package {index + 1} Height</h2>
                    <p>{pkg.dimensions.height}CM</p>
                  </div>
                </div>
              ))}
            </div>
            <div className='databdd'>
              <div className='flex justify-between items-center'>
                <h5>Sender Name</h5>
                <p>
                  {delivery.sender_first_name} {delivery.sender_last_name}
                </p>
              </div>
              <div className='flex justify-between items-center'>
                <h5>Sender Number</h5>
                <p> {delivery.pickup_number}</p>
              </div>
            </div>

            <div className='databdd'>
              <div className='flex justify-between items-center'>
                <h5>Delivery Location </h5>
                <p>
                  {delivery.delivery_address} {delivery.delivery_state}{' '}
                  {delivery.delivery_city}
                </p>
              </div>
              <div className='flex justify-between items-center'>
                <h5>Recipient Name</h5>
                <p>
                  {delivery.receiver_first_name} {delivery.receiver_last_name}
                </p>
              </div>
              <div className='flex justify-between items-center'>
                <h5>Recipient Number</h5>
                <p>{delivery.delivery_number}</p>
              </div>
            </div>

            <div className='acceptText'>
              <p>
                By continuing, I confirm that the information provided above
                accurately describes the contents of my package. To proceed,
                please save this booking as a draft and take your package to the
                nearest drop-off location. An agent will assist you in
                completing the booking process. This step is necessary to verify
                the actual weight and ensure the contents match the declared
                items.
              </p>
            </div>
            <div className='other flex justify-between items-center'>
              <h3> Shipping Cost</h3>
              <h3>
                ₦
                {parseFloat(total.shippingCost).toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </h3>
            </div>
            <div className='other flex justify-between items-center'>
              <h3> Shipment Protection</h3>
              <h3>
                ₦
                {parseFloat(total.insurance).toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </h3>
            </div>
            {total.breakDown.extraCharges.map((data: any) => (
              <div className='other flex justify-between items-center'>
                <h3>{fixAllCap(data.name)}</h3>
                <h3>
                  ₦
                  {parseFloat(data.price).toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </h3>
              </div>
            ))}
            {total.breakDown.discountAmount > 0 && (
              <div className='other flex justify-between items-center'>
                <h3> Discount</h3>
                <h3>
                  -₦
                  {parseFloat(total.breakDown.discountAmount).toLocaleString(
                    'en-US',
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )}
                </h3>
              </div>
            )}
            <div className='cost flex justify-between items-center'>
              <h3> Total Cost</h3>
              <h3 className='price'>
                ₦
                {parseFloat(total.totalPrice).toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </h3>
            </div>
            {/* {profileLoading ? (
              <FormLoader position='center' />
            ) : (
              <div className='databdd'>
                <div className='flex justify-between items-center'>
                  <h5>Wallet Balance</h5>
                  <p>
                    {parseFloat(
                      parseFloat(profile.balance).toFixed(2)
                    ).toLocaleString()}
                  </p>
                </div>
                {parseFloat(total.totalPrice).toFixed(2) > profile?.balance && (
                  <>
                    <p className='red'>Insufficent Amount. Fund wallet</p>
                    <div className='flex justify-between items-center'>
                      <h5>Account Name</h5>
                      <p>
                        {profile.firstname} {profile.lastname}
                      </p>
                    </div>
                    <div className='flex justify-between items-center'>
                      <h5>Account Number</h5>
                      <p>{profile.account_number}</p>
                    </div>
                    <div className='flex justify-between items-center'>
                      <h5>Bank </h5>
                      <p>{profile.bank}</p>
                    </div>
                    <button onClick={fetchUserProfile}>Refresh account</button>
                  </>
                )}
              </div>
            )} */}
            <div>
              {loading ? (
                <FormLoader position='center' />
              ) : (
                <div className='paymentTotalbtn'>
                  {/* <button
                    onClick={() => {
                      parseFloat(total.totalPrice).toFixed(2) > profile?.balance
                        ? () => {}
                        : handleBooking('wallet')
                    }}
                    disabled={
                      parseFloat(total.totalPrice).toFixed(2) > profile?.balance
                    }
                  >
                    Pay with Wallet
                  </button>
                  {profile.turnoff_payment &&
                    parseFloat(total.totalPrice).toFixed(2) >
                      profile?.balance && (
                      <button
                        className='dif'
                        onClick={() => {
                          handleBooking('credit')
                        }}
                      >
                        Proceed on credit
                      </button>
                    )} */}
                  <button
                    className='dif'
                    onClick={() => {
                      saveToDraft()
                    }}
                  >
                    Save to Draft
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
        {/* {modalConfirm && (
          <Modal position='center'>
            <div className='success-modal'>
              <h1>Booking Successful</h1>
              <p>
                Track ID: <b>#{trackingId?.shipmentMeta?.trackingId}</b>
              </p>
              <button onClick={() => navigate('/user/bookings')}>
                Go to Bookings
              </button>
              {draftId && (
                <button onClick={deleteDraft} className='delete'>
                  Delete draft
                </button>
              )}
            </div>
          </Modal>
        )} */}
        {modalConfirm && (
          <Modal position='center'>
            <div className='success-modal'>
              <h1>Draft Saved Successfully</h1>
              <p>
                Proceed to drop-off at the nearest drop-off location. ID:{' '}
                <b>#{trackingId}</b>
              </p>
              <button onClick={() => navigate('/user/drafts')}>
                Go to Drafts
              </button>
            </div>
          </Modal>
        )}
        {prohibitedItem && (
          <Modal position='center'>
            <div className='prohibit-modal'>
              <h2>The underlisted items are Prohibited Items</h2>
              <div className='probitrbody'>
                <ul>
                  <li>
                    Our Courier partners do not have the operational capability
                    to transport such items.
                  </li>

                  <li>
                    Animal or animal’s products contained within Appendix 1 of
                    CITES are prohibited from carriage. The CITES Convention
                    (Convention on International Trade in Endangered Species of
                    Wild Fauna and Flora) is an international agreement between
                    governments concerning the international trade in specimens
                    of wild animals or plants https://www.cites.org/eng. Animal
                    or animal’s products not contained within Appendix 1 of
                    CITES can usually be shipped but may require an export
                    license from the issuing government. See under restricted.
                  </li>

                  <li>
                    These items are prohibited for carriage as the network is
                    not designed to be sufficiently secure for such
                    transportation. It could lead to our Courier partner’s
                    people or property becoming targets of criminal activity.{' '}
                  </li>

                  <li>
                    These items are prohibited for carriage as the network is
                    not designed to be sufficiently secure for such
                    transportation. It could lead to our Courier partner’s
                    people or property becoming targets of criminal activity.
                    The relevant local Authority is to be notified if the amount
                    of cash found exceeds the relevant threshold for
                    notification. - Travellers Cheques & Activated Credit Cards
                    As an exception, certain selected and approved customers who
                    have significant volumes of core network shipments may be
                    permitted to transport Travellers Cheques & Activated Credit
                    Cards (GSOP Shipment and Product Handling Policy and
                    Standards 2.2.14 Travellers Cheques & Activated Credit
                    Cards).
                  </li>

                  <li>
                    These items are prohibited for carriage as our Courier
                    partner’s network is not designed to be sufficiently secure
                    for such transportation. It could lead to its people or
                    property becoming targets of criminal activity.
                  </li>
                  <li>
                    These items are prohibited for carriage in our Courier
                    partner’s network as in many territories special handling
                    and licenses are required for the carrier. Restrictions also
                    apply in airports worldwide for the airside handling of such
                    items. Under x-ray replica firearms resemble real guns and
                    may cause disruption and delay in the screening process.
                  </li>

                  <li>
                    Any goods considered to be illegal are prohibited for
                    carriage as our Courier partners could be held financially
                    and criminally responsible for the movement of such goods.
                    This can include items that are country-specific (e.g. the
                    importation of alcohol and pornography including sex-dolls)
                    and commodities considered to be illegal internationally,
                    such as counterfeit goods and narcotics (e.g. Heroin,
                    Cocaine, Fentanyl and chemicals that may be precursors to
                    narcotic manufacture).
                  </li>
                  <li>
                    Counterfeit goods in breach of intellectual property rights
                    (IPR) are prohibited and carrying them may cause serious
                    harm to the reputation of our Courier partners. As per our
                    policy, all IPR / counterfeit goods and commodities are
                    illegal and are therefore prohibited for carriage.
                  </li>
                </ul>
                <button onClick={() => setProhibitedItem(false)}>Close</button>
              </div>
            </div>
          </Modal>
        )}
      </div>
      {tab === 4 ? <SummaryBanner /> : <DeliveryBanner tab={tab} />}
    </div>
  )
}

export default Domestic
